import React from "react";
import useTranslation from "next-translate/useTranslation";
import styles from "./styles/SignInButton.module.css";
import { FaFacebookF } from "react-icons/fa";

export default function FacebookButton({ onClick, text, size = null }) {
  const { t } = useTranslation("common");

  const sizeStyle = size === "small" ? styles.fbButtonSmall : styles.fbButton;

  return (
    <div className={sizeStyle} onClick={(e) => onClick(e)}>
      <FaFacebookF />
      <div className={styles.signInButtonText}>{t(text)}</div>
    </div>
  );
}
